import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useMemo } from "react";

function DownloadIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const svgValue = useMemo(() => {
    if (fontSize === "small") {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.66667 10V13.2C2.66667 13.4122 2.80715 13.6157 3.0572 13.7657C3.30724 13.9157 3.64638 14 4.00001 14H12C12.3536 14 12.6928 13.9157 12.9428 13.7657C13.1929 13.6157 13.3333 13.4122 13.3333 13.2V10"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.33334 7.33333L8.00001 10L10.6667 7.33333"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M8 10L8 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    } else if (fontSize === "large") {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.33334 20V26.4C5.33334 26.8243 5.61429 27.2313 6.11439 27.5314C6.61449 27.8314 7.29277 28 8.00001 28H24C24.7073 28 25.3855 27.8314 25.8856 27.5314C26.3857 27.2313 26.6667 26.8243 26.6667 26.4V20"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6667 14.6667L16 20L21.3333 14.6667"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M16 20L16 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    }

    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 15V19.8C4 20.1183 4.21071 20.4235 4.58579 20.6485C4.96086 20.8736 5.46957 21 6 21H18C18.5304 21 19.0391 20.8736 19.4142 20.6485C19.7893 20.4235 20 20.1183 20 19.8V15"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11L12 15L16 11"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12 15L12 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }, [fontSize]);

  return <SvgIcon {...props}>{svgValue}</SvgIcon>;
}
export default DownloadIcon;
